import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=0c19921e&"
import script from "./list2.vue?vue&type=script&lang=js&"
export * from "./list2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports